export default __webpack_public_path__ + "static/media/the-beers.4191be53.jpg";